var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tagName)?_c('div',{staticClass:"logistics-tag",style:(_vm.tagStyle)},[_vm._v(" "+_vm._s(_vm.tagName)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }